import React from 'react';

export default function HTML_Browser_Support() {
  return (
    <div className="HTML_Browser_Support">
      <h1>HTML Browser Support</h1>
      <p>This is the placeholder component for <strong>HTML Browser Support</strong>.</p>
      <p>Link: /html/reference/browser-support</p>
    </div>
  );
}
